export default "__VITE_ASSET__DzSmsdZZ__"